import { render } from "./Provinces.vue?vue&type=template&id=36012178"
import script from "./Provinces.vue?vue&type=script&lang=js"
export * from "./Provinces.vue?vue&type=script&lang=js"
script.render = render

export default script